import * as React from "react";
import { Button, Rating, makeStyles, shorthands, Field, Textarea } from "@fluentui/react-components";
import { useForm, Controller } from "react-hook-form";
import { FeedbackDetails, FeedbackInputs } from "./types";
import { postFeedback } from "./utilities";

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    ...shorthands.gap("10px"),
  },
});

const Feedback = ({
  props,
}: {
  props: {
    feedbackDetails: FeedbackDetails;
    informFunction: (input: string) => void;
    closeFunction: () => void;
    errorFunction?: (input: string) => void;
  };
}) => {
  const classes = useStyles();

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<FeedbackInputs>();

  const [loading, setLoading] = React.useState<boolean>(false)

  const onSubmit = async (inputs: FeedbackInputs) => {
    setLoading(true)
    const response = await postFeedback(
      {
        response: props.feedbackDetails.response,
        rating: inputs.rating,
        feedback: inputs.feedback,
        email: props.feedbackDetails.email,
        model: props.feedbackDetails.model,
        conversationId: props.feedbackDetails.conversationId,
      },
      props.feedbackDetails.token
    );
    setLoading(false)
    if (response.error){
      props.errorFunction(response.error)
    }
    else {
      props.informFunction(response.message);
      props.closeFunction()
    }
  };

  return (
    <div>
      <form className={classes.root} onSubmit={handleSubmit(onSubmit)}>
        <Field
          label="Rate the response"
          required
          validationMessage={"Rating is required"}
          validationState={errors.rating ? "error" : "none"}
        >
          <Controller
            name="rating"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <Rating max={5} name="Rating" color="brand" onChange={(_, data) => field.onChange(data.value)} />
            )}
          />
        </Field>

        <Field
          label="Provide some additional information"
          required
          validationMessage="Feedback is required"
          validationState={errors.feedback ? "error" : "none"}
        >
          <Controller
            name="feedback"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <Textarea
                placeholder="Type here..."
                resize="vertical"
                onChange={(_, data) => field.onChange(data.value)}
              />
            )}
          />
        </Field>

        <Button type="submit" appearance="primary" disabled={loading}>
          Submit feedback
        </Button>
      </form>
    </div>
  );
};

export default Feedback;
